import { Type } from "./type";
import { authRepository } from "@/modules/auth/repositories";
import { useToast } from "vue-toastification";
import router from "@/routes";
const toast = useToast();

export const registerModule = {
  namespaced: true,
  state: () => ({}),
  getters: {},
  mutations: {},
  actions: {
    async [Type.REGISTER_CONFIRM]({ commit }, payload) {
      let afterRegister;
      if (localStorage.getItem("afterAuthorizeCompelete"))
        afterRegister = {
          ...JSON.parse(localStorage.getItem("afterAuthorizeCompelete")),
        }.value;
      try {
        const { data } = await authRepository.otpConfimRegister(payload);
        commit("auth/login/submitLoginSuccess", data?.data?.result, {
          root: true,
        });
        if (afterRegister) {
          router.push(afterRegister);
        } else router.push("/");
      } catch (error) {
        console.error(error);
      }
    },
  },
};
